/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import Consultoria from "pages/Servicos/Consultoria";

export default function ConsultoriaPage() {
  return <Consultoria />;
}
